'use strict';

var ad_toggle_visibility = function () {
  var self = this;

  self.init();
  self.bind();
};


ad_toggle_visibility.prototype.bind = function () {
  var self = this;

  $(document).arrive('.ad_toggle_visibility', function (localSelf) {
    localSelf.init_items();
  }.bind(null, self));

};


ad_toggle_visibility.prototype.init = function () {
  var self = this;

  $(document).on('change', '.ad_toggle_visibility', function(localSelf, event) {
      var selector = $(event.target).attr('id'),
          selected = $(event.target).val();

      localSelf.update_visibility(selector, selected);
  }.bind(null, self)  );

  self.init_items();

};

ad_toggle_visibility.prototype.update_visibility = function (selector, selected) {
  var self = this;

  $('div.'+selector).hide();
  $('div#'+selector+'-'+selected).show();
};



ad_toggle_visibility.prototype.init_items = function () {
  var self = this;

  $('.ad_toggle_visibility').each( function (/* index*/) {
      var element = $(this);

      if (element.hasClass('st_mounted') === false) {
        element.trigger('change');
        element.addClass('st_mounted');
      }
  });

};



$( document ).ready(function() {

  window.ad_toggle_visibility = new ad_toggle_visibility();

});
